import { FormFieldGroup, FormLabel, FormLabelDescription, FormTextarea } from '$components'
import { Input } from './index'

export function EditNotesContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.GroomingPreferences}>
          Grooming Preferences
        </FormLabel>

        <FormLabelDescription>
          Add any notes about grooming preferences.
        </FormLabelDescription>

        <FormTextarea
          name={Input.GroomingPreferences}
          placeholder="Enter grooming preferences..."
          rows={4}
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.InternalNotes}>
          Internal Notes
        </FormLabel>

        <FormLabelDescription>
          Add any internal notes about this pet (only visible to you and your team).
        </FormLabelDescription>

        <FormTextarea
          name={Input.InternalNotes}
          placeholder="Enter internal notes..."
          rows={4}
        />
      </FormFieldGroup>
    </div>
  )
}
